import { render, staticRenderFns } from "./ShipperCutoffGroupBulkUpdate.vue?vue&type=template&id=3e980138"
import script from "./ShipperCutoffGroupBulkUpdate.vue?vue&type=script&lang=js"
export * from "./ShipperCutoffGroupBulkUpdate.vue?vue&type=script&lang=js"
import style0 from "./ShipperCutoffGroupBulkUpdate.vue?vue&type=style&index=0&id=3e980138&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports